import { render, staticRenderFns } from "./DueDateEditDialog.vue?vue&type=template&id=a0e5d060&scoped=true"
import script from "./DueDateEditDialog.vue?vue&type=script&lang=js"
export * from "./DueDateEditDialog.vue?vue&type=script&lang=js"
import style0 from "./DueDateEditDialog.vue?vue&type=style&index=0&id=a0e5d060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0e5d060",
  null
  
)

export default component.exports